import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import toggleFiltersOpen from "@insite/client-framework/Store/Pages/SavedOrderList/Handlers/ToggleFiltersOpen";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon, ButtonIconPresentationProps, ButtonPresentationProps } from "@insite/mobius/Button";
import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Filter from "@insite/mobius/Icons/Filter";
import Minus from "@insite/mobius/Icons/Minus";
import Plus from "@insite/mobius/Icons/Plus";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

import { isMgbwWebsite } from "@tSurya/Common/Utilities/websiteUtils";
import MyAccountThemeWrapper from "@tSurya/Utils/MyAccountThemeWrapper";
import SuryaPageThemeWrapper from "@tSurya/Utils/SuryaPageThemeWrapper";

const mapStateToProps = (state: ApplicationState) => {
    return {
        isFiltersOpen: state.pages.savedOrderList.isFilterOpen
    };
};
const mapDispatchToProps = {
    toggleFiltersOpen,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;


export interface SavedOrderListHeaderStyles {
    container?: GridContainerProps;
    titleGridItem?: GridItemProps;
    emptyGridItem?: GridItemProps;
    toggleFilterGridItem?: GridItemProps;
    /** @deprecated Use toggleFilterButtonIcon instead. */
    toggleFilterIcon?: IconPresentationProps;
    /** @deprecated Use toggleFilterButton instead. */
    toggleFilterClickable?: ClickablePresentationProps;
    toggleFilterButton?: ButtonPresentationProps;
    toggleFilterButtonIcon?: ButtonIconPresentationProps;
}

export const savedOrderListHeaderStyles: SavedOrderListHeaderStyles = {
    container: {
        gap: 8,
        css: css`
            padding-bottom: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                         padding-bottom: 0px;
                    `,
                    css`
                        padding-bottom: 0px;
                    `,
                    css`
                        padding-bottom: 0px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    titleGridItem: {
        width: 12,
        style: { fontWeight: 600 },
    },
    toggleFilterGridItem: {
        width: 12,
        style: { justifyContent: "flex-end" },
    },
    toggleFilterButton: {
        color: "common.background",
        shape: "pill",
        buttonType: "solid",
        shadow: false,
        css: css`
            width: 40px;
            padding: 0;
        `,
    },
    toggleFilterButtonIcon: {
        src: Filter,
        size: 24,
    },
};
const styles = savedOrderListHeaderStyles;

const SavedOrderListHeader = ({ toggleFiltersOpen,isFiltersOpen, id }: Props) => {
    const ThemeWrapper = isMgbwWebsite() ? SuryaPageThemeWrapper : MyAccountThemeWrapper;
    const [isPulsing, setIsPulsing] = useState(true);
    
    const handleClick = () => {
        setIsPulsing(prevState => !prevState);
        toggleFiltersOpen();
    };
    useEffect(() => {
        if(!isFiltersOpen) {
            toggleFiltersOpen();

        }
      }, []);
    return (
        <ThemeWrapper>
            <GridContainer {...styles.container}>
                <GridItem {...styles.titleGridItem}>
                    <Zone contentId={id} zoneName="Content" />
                </GridItem>
                {/* <GridItem {...styles.toggleFilterGridItem}>
                <span className="pulse" onClick={() => handleClick()}>
                    {isPulsing ? (
                        <Icon src={Minus} size={14} />
                    ) : (
                        <Icon src={Plus} size={14} />
                    )}
                </span>
                    <Button
                        {...styles.toggleFilterButton}
                        onClick={() => toggleFiltersOpen()}
                        data-test-selector="savedOrderList_showHideFilters"
                    >
                        <ButtonIcon {...styles.toggleFilterButtonIcon} />
                    </Button>
                </GridItem> */}
            </GridContainer>
        </ThemeWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SavedOrderListHeader),
    definition: {
        group: "Saved Order List",
        displayName: "Header",
        allowedContexts: ["SavedOrderListPage"],
    },
};

export default widgetModule;
